export default {
      id: "track-complaint2-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#track-complaint2",
      toString: function () {
        return this.url;
      }
    }